<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/yeti/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "Rambler Beverage Bucket", 
		src: imagesGlob["../../images/brands/yeti/products/swaggerproductpagewebsiteproductsyeti1beverage-bucket.png"].default
	},
	{
		title: "Rambler 30 oz. Tumbler", 
		src: imagesGlob["../../images/brands/yeti/products/swaggerproductpagewebsiteproductsyeti4tumbler.png"].default
	},
	{
		title: "Rambler 26 oz. Chug Cap Bottle", 
		src: imagesGlob["../../images/brands/yeti/products/swaggerproductpagewebsiteproductsyeti3water-bottle.png"].default
	},
	{
		title: "Rambler 42 oz. Straw Mug", 
		src: imagesGlob["../../images/brands/yeti/products/swaggerproductpagewebsiteproductsyeti5straw-mug.png"].default
	},
	{
		title: "Hopper Flip 18 Soft Cooler", 
		src: imagesGlob["../../images/brands/yeti/products/swaggerproductpagewebsiteproductsyeti7hopper-flip-soft-cooler.png"].default
	},
	{
		title: "Rambler Colster Can Cooler", 
		src: imagesGlob["../../images/brands/yeti/products/swaggerproductpagewebsiteproductsyeti8colster-can-cooler.png"].default
	},
	{
		title: "Rambler 10 oz. Wine Tumbler", 
		src: imagesGlob["../../images/brands/yeti/products/swaggerproductpagewebsiteproductsyeti2wine-tumbler.png"].default
	},
	{
		title: "20 oz. Camino Carryall Tote Bag", 
		src: imagesGlob["../../images/brands/yeti/products/swaggerproductpagewebsiteproductsyeti9carryall-tote-bag.png"].default
	},
	{
		title: "Rambler 10 oz. Lowball",
		src: imagesGlob["../../images/brands/yeti/products/swaggerproductpagewebsiteproductsyeti6stackable-lowball.png"].default
	},

]
</script>

<template lang="pug">
.page.page--brand.yeti
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/yeti/logo.png')
				h1 Custom Yeti
			.image
				img(src='@static/images/brands/yeti/hero.jpg' alt="Person wearing a black YETI cooler backpack and brown sweater, walking outdoors near a shoreline.")
	section.section.section--subhero
		.section__content
			.copy
				h3 BUILT FOR THE WILD
				p YETI is known for raising the bar on durability, performance, and everyday cool. Whether it’s a tumbler that keeps your coffee hot for hours or a cooler that holds ice for days, YETI gear is designed to thrive in the most rugged environments, and look good doing it. From road trips and hikes to office desks and backyard BBQs, their products make a statement: tough, intentional, and made to last.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom Yeti ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="yeti")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/yeti/banner.jpg' alt="Coffee being poured into black and blue YETI cups lined on a wood log outdoors.")
			.section__content
				.copy
					h2 PREMIUM BY NATURE
					p YETI proves you don’t need to shout to make a statement. With clean lines, premium finishes, and retail-quality craftsmanship, their gear earns daily use and genuine appreciation. Whether laser-etched or subtly screen printed, branded YETI stands apart as a mark of quality and intentional style. It’s the kind of quiet cool that’s premium, purposeful, and effortlessly stylish.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>